module.exports = __webpack_public_path__ + "static/media/pic1.154cbcc3.jpg";